import * as React from 'react';

function SvgIconHint(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 1a7 7 0 10.001 14.001A7 7 0 008 1zm.5 10.375a.125.125 0 01-.125.125h-.75a.125.125 0 01-.125-.125v-4.25c0-.069.056-.125.125-.125h.75c.069 0 .125.056.125.125v4.25zM8 6a.75.75 0 010-1.5A.75.75 0 018 6z"
        fill="#F9A600"
      />
    </svg>
  );
}

export default SvgIconHint;
